// extracted by mini-css-extract-plugin
export var actions = "_cg-d";
export var benefitCard = "_cg-a";
export var benefitIcon = "_cg-b";
export var benefitLabel = "_cg-c";
export var benefits = "_cg-9";
export var bodyText = "_cg-8";
export var closeButton = "_cg-2";
export var content = "_cg-3";
export var eyebrow = "_cg-4";
export var heading = "_cg-5";
export var image = "_cg-f";
export var imagePanel = "_cg-e";
export var modal = "_cg-0";
export var shell = "_cg-1";
export var title = "_cg-6";
export var titleOffer = "_cg-7";